export const dealSetups = (state) => state?.entities?.dealSetup;
